import React, { useState, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../../../config/backend';

import '../../styles/inventario.css';
import './DocumentarManutencao.css';

function NovoHistoricoHardware(props) {

    const history = useHistory();

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState("");

    const [desHis, setDesHis] = useState('');

    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('N');

    const pegarHardware = async (e) => {

        let listaHardware = [];

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware/ativos", {
                headers: {
                    Authorization: `${token}`
                }
            });
            let i = 0;

            while (i < response.data.length) {

                listaHardware.push({
                    codHar: response.data[i].CODHAR,
                    serEqp: response.data[i].SEREQP,
                    patEqp: response.data[i].PATEQP,
                    nomEqp: response.data[i].NOMEQP
                })
                i++;
            }
            setData(listaHardware);

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const verificarCampos = async () => {

        if (desHis.trim() === '') {
            setMensagem("Atenção deve ser inserido a documentação realizada!")
            return;
        }

        setMensagem("");
    };

    const inserindoDocumentacao = async () => {

        verificarCampos();
        verificandoToken();

        const token = localStorage.getItem('token');

        let codHar = selected;

        try {

            await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hishardware",
                { codHar, desHis },
                {
                    headers: {
                        Authorization: `${token}`
                    }
                });

            setMensagem('');
            setSucesso('S');
        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }
    };

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    useEffect(() => {

        verificar();
        pegarHardware();

        if (props.match.params.id) {
            setSelected(props.match.params.id);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo inventario-page">
            <div className="col-4">
                <h1>Documentar Manutenção</h1>
            </div>
            <form>

                <div className="col">
                    <label htmlFor="exampleInputEmail1">Hardware</label>
                    <select className="form-control disable" value={selected} onChange={(e) => { setSelected(e.target.value) }}>
                        <option value="">Selecione...</option>
                        {data.map((opt) => (
                            <option key={opt.codHar} value={opt.codHar}>
                                {opt.nomEqp + " - " + opt.serEqp + " - " + opt.patEqp}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group mb-1">
                    <label htmlFor="exampleInputEmail1">Descrição</label>
                    <textarea type="email" className="form-control" rows={20} onChange={(e) => setDesHis(e.target.value)} value={desHis} id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Documentar a manutenção do equipamento" />
                </div>

                <button onClick={inserindoDocumentacao} type="button" className="btn btn-secondary btn-acao mt-4">Salvar</button>
                <Link to="/listaHardware" className="btn btn-outline-secondary btn-acao mt-4 ml-2">Voltar ao Inventário</Link>
            </form>

            {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {sucesso === 'S' ? <Redirect to='/listaHardware' /> : null}
            </div>
            </main>
        </div>
    );
}

export default NovoHistoricoHardware;
